import { BetrokkenTrein } from "@/entities/betrokken-treinen";
import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    ErrorDisplay,
    Form,
    FormFieldInput,
} from "@/shared/components";
import { hourFormatInAmsterdam, Time, timeToDate } from "@/shared/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import z from "zod";

const etaBewerkenSchema = z.object({
    eta: z.iso.time({ error: (issue) => (issue.input === undefined ? "Vul de ETA in" : "Vul een geldige tijd in") }),
});

type BusEvacuatieEtaBewerkenDialogProps = {
    trein: BetrokkenTrein;
    currentEta: Date;
    open: boolean;
    setOpen: (open: boolean) => void;
    onSubmit: (updatedEta: Date) => void;
    isPending?: boolean;
    error?: Error | null;
};

type ETABewerkenData = z.infer<typeof etaBewerkenSchema>;

export function BusEvacuatieEtaBewerkenDialog({
    open,
    setOpen,
    currentEta,
    trein,
    onSubmit,
    error,
    isPending,
}: BusEvacuatieEtaBewerkenDialogProps) {
    const form = useForm<ETABewerkenData>({
        resolver: zodResolver(etaBewerkenSchema),
        defaultValues: {
            eta: hourFormatInAmsterdam(currentEta),
        },
    });

    function handleOpenChange(isOpen: boolean) {
        if (!isOpen) {
            form.reset();
        }
        setOpen(isOpen);
    }

    function onSubmitHandler(data: ETABewerkenData) {
        const etaDateTime = timeToDate(data.eta as Time);
        onSubmit(etaDateTime);
    }

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContainer>
                <DialogHeader>
                    <DialogTitle>ETA bewerken evacuatiebus {BetrokkenTrein.formatTrainLabel(trein)}</DialogTitle>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={(e) => void form.handleSubmit(onSubmitHandler)(e)}>
                        <DialogBody className="grid gap-4">
                            <FormFieldInput form={form} name="eta" label="ETA" type="time" className="max-w-2/5" />
                        </DialogBody>
                        <DialogFooter>
                            <Button type="button" variant="tertiary" onClick={() => handleOpenChange(false)}>
                                Annuleren
                            </Button>
                            <Button type="submit" variant="primary" disabled={isPending}>
                                Opslaan
                            </Button>
                            {error && <ErrorDisplay error={error} />}
                        </DialogFooter>
                    </form>
                </Form>
            </DialogContainer>
        </Dialog>
    );
}
